export class TextAnimation {
  active = false;
  direction = 'left';
  speed = 8;
}
